import PlataformUserApi from './user'
import PlataformAuthApi from './auth'
import PlataformNotificationApi from './notification'
import PlataformHeaderApi from './header'
import PlataformFaculdadeApi from './faculdade'
import PlataformConteudoApi from './conteudo'
import PlataformEmpresaApi from './empresa'

export const PlataformApi = {
  async getFaculdades () { return await PlataformFaculdadeApi.get() },

  async getUser () { return await PlataformUserApi.getUser() },

  async passwordResetSolicitation (email) { return await PlataformUserApi.passwordResetSolicitation(email) },

  async logout () { return await PlataformAuthApi.logout() },

  async login (data) { return await PlataformAuthApi.login(data) },

  async socialLogin (data) { return await PlataformAuthApi.socialLogin(data) },

  async createSocialUser (data) { return await PlataformAuthApi.createSocialUser(data) },

  async getNotification (id, pagina) { return await PlataformNotificationApi.getNotification(id, pagina) },
  
  async getNotificationByType (id) { return await PlataformNotificationApi.loggetNotificationByTypeout(id) },

  async getNotificationTypes () { return await PlataformNotificationApi.getNotificationTypes() },

  async registerVisualization (notificacoesIds) { return await PlataformNotificationApi.registerVisualization(notificacoesIds) },

  async registerAccess (id) { return await PlataformNotificationApi.registerAccess(id) },

  async toggleDarkMode () { return await PlataformHeaderApi.toggleDarkMode() },

  async listarCursos () { return await PlataformConteudoApi.listarCursos() },

  async listarDisciplinas () { return await PlataformConteudoApi.listarDisciplinas() },

  async listarLicoes () { return await PlataformConteudoApi.listarLicoes() },
  
  async listarCategorias () { return await PlataformConteudoApi.listarCategorias() },
  
  async registraVisualizacaoPdf (resumo) { return await PlataformConteudoApi.registraVisualizacaoPdf(resumo) },

  async pegaConfiguracaoWL (subdominio) { return await PlataformEmpresaApi.pegaConfiguracaoWL(subdominio) }
}

export default PlataformApi
